/*
 * @Author: cc
 * @Date: 2020-04-05 16:34:53
 * @LastEditTime: 2020-05-04 17:08:08
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\newspaper\sampleReview\sampleReviewRouter.js
 * @Description: 
 */
'use strict';
angular.module('newspaperSampleReviewRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {

        /**
         * [url description] 大样审阅
         * @type {String}
         */
        $stateProvider.state('sampleReview', {
            url: '/sampleReview?paperid&oprtime',
            views: {
                '': {
                    templateUrl: './editingCenter/newspaper/sampleReview/sampleReview_tpl.html',
                    controller: 'newspaperSampleReviewCtrl'
                }
            }
        })
            .state('newspapersampledetail', {
                url: '/sampledetail?composeId&DIECINAME&PAGENAME&src&banPositon&diePosition&paperid&status',
                views: {
                    '': {
                        templateUrl: './editingCenter/newspaper/sampleReview/sampleDetail/sampleDetail_tpl.html',
                        controller: 'editCenNewspaperSampleDetailCtrl'
                    }
                }
            })
            .state('newspapersampleUpload', {
                url: '/sampleUpload?paperid',
                views: {
                    '': {
                        templateUrl: './editingCenter/newspaper/sampleReview/sampleUpload/sampleUpload_tpl.html',
                        controller: 'newspaperSampleUploadCtrl'
                    }
                }
            });
    }]);
